import React, { useMemo, useState, useEffect } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons/faPlusCircle'
import { faArrowCircleLeft } from '@fortawesome/pro-regular-svg-icons/faArrowCircleLeft'
import { Helmet } from 'react-helmet'
import { HydraTable, Heading } from '@peracto/peracto-ui'
import { useConfig } from '@peracto/peracto-config'
import { GET_LIST, useClient } from '@peracto/client'
import { useParams } from 'react-router-dom'

const ProductMenuItemRelationsList = () => {
    const config = useConfig()
    const { id } = useParams()
    const { client } = useClient()
    const { products } = config.get('features', {})

    const [redirect, setRedirect] = useState()

    useEffect(() => {
        if (!products?.productMenuItemRelations) {
            setRedirect(`/products/${id}`)
        }
    }, [products])

    // The 'selectable' property is used to define if the
    // column is available in the 'manage columns' dropdown
    const columns = useMemo(() => [
        {
            Header: 'Menu Item Label',
            accessor: 'label',
            Cell: row => {
                return (
                    <Link
                        to={`/products/${id}/menu-item-relations/${row.row.original.originId}`}
                        data-testid={`row-${row.row.index}-label`}
                    >
                        {row.cell.value || 'N/A'}
                    </Link>
                )
            },
        },
        {
            Header: 'Display Order',
            accessor: 'displayOrder',
            sortType: 'basic',
            Cell: ({ cell: { value } }) => value,
            selectable: false,
        },
    ])

    const onFetchData = options => client(GET_LIST, 'product-menu-item-relations', options)

    return (
        <>
            {redirect && <Redirect to={redirect} />}
            <Helmet>
                <title>Product Menu Item Relations | Peracto</title>
            </Helmet>
            <Heading name="Product Menu Item Relations">
                <div className="!ml-2 !flex !items-center">
                    <Link
                        className="!mr-2 btn btn-outline-primary"
                        to={`/products/${id}`}
                        data-testid="back-to-product"
                    >
                        <FontAwesomeIcon icon={faArrowCircleLeft} className="!mr-2" />
                        Back to Product
                    </Link>

                    <Link
                        className="btn btn-primary"
                        to={`/products/${id}/menu-item-relations/add`}
                        data-testid="add-product-menu-item-relation"
                    >
                        <FontAwesomeIcon icon={faPlusCircle} className="!mr-2" />
                        Add Menu Item Relation
                    </Link>
                </div>
            </Heading>

            <div className="row">
                <div className="col">
                    <div className="card card--transparent">
                        <div className="card-body">
                            <HydraTable
                                columns={columns}
                                onFetchData={onFetchData}
                                alwaysFilter={{
                                    product: id,
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProductMenuItemRelationsList
